import { Pipe, PipeTransform } from '@angular/core';

import { parseNumberFromText } from '../utils/number.format';

@Pipe({
	name: 'copoTextToNumber',
})
export class TextToNumberPipe implements PipeTransform {
	transform(value: string | undefined) {
		return parseNumberFromText(value);
	}
}
